import { render } from "./SortCategoryProducts.vue?vue&type=template&id=beb402b8&ts=true"
import script from "./SortCategoryProducts.vue?vue&type=script&lang=ts"
export * from "./SortCategoryProducts.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__